import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { CalendarModule } from "primeng/calendar";

@Component({
  selector: "app-termination-date",
  standalone: true,
  imports: [CommonModule, CalendarModule, TranslateModule, ReactiveFormsModule],
  templateUrl: "./termination-date.component.html",
})
export class TerminationDateComponent {
  @Input() form!: FormGroup;
  @Input() minTerminationDate!: Date | null;
  @Input() maxTerminationDate!: Date | null;
  RequestNatureOptions = RequestNatureOptions;
}
